// extracted by mini-css-extract-plugin
export default {"separation_line_horizontal":"goldLineSeparator_separation_line_horizontal__9cT5X"};